module.exports = __webpack_public_path__ + "img/exact_location_marker.15f27d6ceb44b9f83de5fd3627793def.png";